import { Button, PasswordField, Sheet } from '@/components/ui'
import { useAppStore } from '@/store/appStore'
import { useUiStore } from '@/store/uiStore'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { authErrorText } from './authErrors'

/**
 * Session expired with work still on the phone: sign in again without losing
 * it. Same account only — the username is fixed, the queue belongs to it.
 */
export function ReauthSheet() {
  const { t } = useTranslation()
  const open = useUiStore((s) => s.reauthOpen)
  const close = useUiStore((s) => s.closeReauth)
  const reauth = useAppStore((s) => s.reauth)
  const username = useAppStore((s) => s.session?.user.username ?? '')
  const pending = useAppStore((s) => s.outboxKeys.size)
  const [password, setPassword] = useState('')
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(null)

  async function submit() {
    if (!password || busy) return
    setBusy(true)
    try {
      await reauth(password)
      setPassword('')
      close()
    } catch (err) {
      setError(authErrorText(err, t))
    } finally {
      setBusy(false)
    }
  }

  return (
    <Sheet
      open={open}
      onOpenChange={(v) => (v ? undefined : close())}
      title={t('reauthTitle')}
      footer={
        <Button disabled={!password} busy={busy} onClick={() => void submit()}>
          {t('loginSubmit')}
        </Button>
      }
    >
      <p className="t-body">{t('reauthBody', { count: pending, username })}</p>
      <PasswordField
        label={t('loginPasswordLabel')}
        value={password}
        onChange={(v) => {
          setPassword(v)
          setError(null)
        }}
        error={error}
        autoComplete="current-password"
        enterKeyHint="go"
        onEnter={() => void submit()}
      />
    </Sheet>
  )
}
